import React, { useState } from 'react';
import { Helmet } from 'react-helmet'; // ▼▼▼ ADDED ▼▼▼
import { useLocation } from 'react-router-dom'; // ▼▼▼ ADDED ▼▼▼
import './Garden.css';

const Garden = () => {
    const [lightboxImage, setLightboxImage] = useState(null);
    const { pathname } = useLocation(); // ▼▼▼ ADDED ▼▼▼

    // ▼▼▼ ADDED ▼▼▼
    // Function to open the lightbox
    const openLightbox = (imageSrc) => {
        setLightboxImage(imageSrc);
    };

    return (
        // ▼▼▼ Wrapped with Fragment <> ▼▼▼
        <>
            {/* ▼▼▼ ADDED THIS ENTIRE HELMET BLOCK ▼▼▼ */}
            <Helmet>
                <title>庭園文化と静寂の宿｜5つの魅力｜金沢之旅宿 あけぼの</title>
                <meta name="description" content="金沢之旅宿あけぼので、静寂に包まれた約100坪のプライベートな庭園をご堪能ください。茶の湯の精神が息づく金沢の庭園文化に触れ、四季折々の美しさを楽しむ滞在を。" />
                <link rel="canonical" href={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:title" content="庭園文化と静寂の宿｜金沢之旅宿 あけぼの" />
                <meta property="og:description" content="静寂に包まれた約100坪のプライベートな庭園をご堪能ください。茶の湯の精神が息づく金沢の庭園文化に触れる滞在を。" />
                <meta property="og:url" content={`https://kanazawa-stay-akebono.com${pathname}`} />
                <meta property="og:image" content="https://kanazawa-stay-akebono.com/images/feature-garden.jpg" />
            </Helmet>
            {/* ▲▲▲ ADDITION ENDS HERE ▲▲▲ */}

            <div className="akebono-garden-page">

                {/* HEROセクション */}
                <section className="akebono-garden-hero" style={{ backgroundImage: "url('/images/feature-garden.jpg')" }}>
                    <div className="akebono-garden-hero-overlay">
                        <h1>庭園文化と静寂の宿</h1>
                    </div>
                </section>

                {/* セクション①：金沢の庭園文化 */}
                <section className="akebono-garden-culture">
                    <h2>金沢の庭園文化とは？</h2>
                    <p>
                        金沢は、加賀百万石の城下町として栄えた歴史を持ち、茶の湯や能楽などと並んで「庭園文化」も深く根付いた都市です。
                        日本三名園のひとつ「兼六園」をはじめ、武家文化と茶の湯の精神が融合した、静謐で奥深い庭園が点在しています。
                    </p>
                    <p>
                        茶の湯における“もてなし”の精神は、庭の設えにも反映されています。露地や苔庭、ししおどし、手水鉢などが心を整える空間として整えられ、季節の移ろいとともに五感で自然を感じる場となっています。
                    </p>
                    <p>
                        金沢の庭園は、単なる観賞用ではなく、暮らしと結びついた“生きた美”として今も息づいています。
                    </p>
                    <div className="akebono-garden-gallery">
                        {/* ▼▼▼ ADDED onClick HANDLERS ▼▼▼ */}
                        <img src="/images/kanazawa-garden1.jpg" alt="春の兼六園" onClick={() => openLightbox('/images/kanazawa-garden1.jpg')} />
                        <img src="/images/kanazawa-garden2.jpg" alt="冬の金沢城公園" onClick={() => openLightbox('/images/kanazawa-garden2.jpg')} />
                        <img src="/images/kanazawa-garden3.jpg" alt="秋の松風閣庭園" onClick={() => openLightbox('/images/kanazawa-garden3.jpg')} />
                    </div>
                </section>

                {/* セクション②：あけぼのの庭園紹介 */}
                <section className="akebono-garden-feature">
                    <h2>あけぼのの庭園</h2>
                    <p>
                        金沢之旅宿 あけぼのでは、約100坪の庭園が町家の中心に広がっています。苔むした石、四季の植栽、飛び石の小径など、まるで茶室へ向かう露地のような静かな佇まいが魅力です。
                        宿のどの部屋からも庭の景色を楽しむことができ、春には桜、夏は青もみじ、秋には紅葉、冬は雪景色と、まるで四季が織りなす一幅の絵画のような時間をお過ごしいただけます。
                    </p>
                    <div className="akebono-garden-gallery">
                        {/* ▼▼▼ ADDED onClick HANDLERS ▼▼▼ */}
                        <img src="/images/garden1.png" alt="春の庭園" onClick={() => openLightbox('/images/garden1.png')} />
                        <img src="/images/garden2.jpg" alt="秋の紅葉" onClick={() => openLightbox('/images/garden2.jpg')} />
                        <img src="/images/garden3.jpg" alt="部屋から眺める庭園" onClick={() => openLightbox('/images/garden3.jpg')} />
                    </div>
                </section>

                {/* セクション③：金沢名庭園まち歩きモデルコース */}
                <section className="akebono-garden-tour">
                    <h2>金沢名庭園まち歩き</h2>
                    <p>
                        金沢市内には、兼六園以外にも個性豊かな庭園が数多く残されています。
                    </p>

                    <div className="garden-card">
                        <img src="/images/spot-terashima.jpg" alt="寺島蔵人邸" onClick={() => openLightbox('/images/spot-terashima.jpg')} />
                        <div>
                            <h3>寺島蔵人邸</h3>
                            <p>武家文化を伝える庭園。ドウダンツツジが見事です。</p>
                        </div>
                    </div>

                    <div className="garden-card">
                        <img src="/images/spot-gyokusen.jpg" alt="西田家庭園 玉泉園" onClick={() => openLightbox('/images/spot-gyokusen.jpg')} />
                        <div>
                            <h3>西田家庭園 玉泉園</h3>
                            <p>茶室「灑雪亭」があり、茶の湯の体験も可能。</p>
                        </div>
                    </div>
                    {/* ... Other garden cards remain the same ... */}
                </section>

                {/* Lightbox 拡大表示 */}
                {lightboxImage && (
                    <div className="lightbox" onClick={() => setLightboxImage(null)}>
                        {/* ▼▼▼ CORRECTED LIGHTBOX ▼▼▼ */}
                        <span className="lightbox-close">&times;</span>
                        <img src={lightboxImage} alt="拡大表示" className="lightbox-content" />
                    </div>
                )}

                {/* セクション④：しめくくりメッセージ */}
                <section className="akebono-garden-closing">
                    <h2>庭のある時間を、宿で</h2>
                    <p>
                        金沢の名庭園が語る美意識と心のあり方。その余韻を宿でも体験できる場所、それが「あけぼの」です。静寂に包まれた庭を眺めながら、日常を離れて心を整えるひとときをお過ごしください。
                    </p>
                </section>

            </div>
        </> // ▲▲▲ Wrapped with Fragment <> ▲▲▲
    );
};

export default Garden;